// Google drive url regex
const driveUrlRegex =
  /^(?:https:\/\/(?:www\.)?(?:drive\.google\.com\/(?:file\/d\/|open\?id=)|dropbox\.com\/(?:sh|s)\/[a-zA-Z0-9]+\/?[a-zA-Z0-9_.-]*))([a-zA-Z0-9_-]+)(?:&.*)?$/;

// Resolution regex ex:- 1200 px x 1300 px
const resolutionRegex = /^\d{3,4}\s*(?:px\s*)?x\s*\d{3,4}\s*(?:px)?$/i;

export { driveUrlRegex, resolutionRegex };
